import type { BatchReceiptDetails } from '../ReceiptBatchForm';
import { v4 as uuid } from 'uuid';
import {
  redistributeFees as redistributeFeesShared,
  type BatchReceiptDetailsWithFees,
} from '@pflegenavi/shared/frontend';

export const createNewReceipt = (
  additionalFeeAmount: number,
  includedFeeAmount: number
): BatchReceiptDetails => ({
  id: `new-${uuid()}`,
  residentId: undefined,
  amount: undefined,
  notes: '',
  receiptImageIds: [],
  residentActive: true,
  individualDate: undefined,
  additionalFeeAmount: additionalFeeAmount,
  includedFeeAmount: includedFeeAmount,
});

/**
 * Redistributes fees across receipt batch entries.
 * Uses shared implementation from @pflegenavi/shared/frontend
 *
 * @param receipts Array of receipt batch entries
 * @param separateFeeAmount Total separate fee amount (additional_fee_amount)
 * @param immediateFeeAmount Total immediate fee amount (included_fee_amount)
 * @returns Updated receipts with redistributed fees
 */
export const redistributeFees = (
  receipts: BatchReceiptDetails[],
  separateFeeAmount: number,
  immediateFeeAmount: number
): BatchReceiptDetails[] => {
  // Convert to shared type, call shared function, then convert back
  const result = redistributeFeesShared(
    receipts as unknown as BatchReceiptDetailsWithFees[],
    separateFeeAmount,
    immediateFeeAmount
  );
  return result as unknown as BatchReceiptDetails[];
};

export const removeReceiptWithFeeRedistribution = (
  receipts: BatchReceiptDetails[],
  indexToRemove: number,
  separateFeeAmount: number,
  immediateFeeAmount: number
): BatchReceiptDetails[] => {
  const newReceipts = receipts.toSpliced(indexToRemove, 1);

  if (newReceipts.length > 0) {
    return redistributeFees(newReceipts, separateFeeAmount, immediateFeeAmount);
  } else {
    return newReceipts;
  }
};

export const addNewReceiptWithFeeRedistribution = (
  receipts: BatchReceiptDetails[],
  separateFeeAmount: number,
  immediateFeeAmount: number
): BatchReceiptDetails[] => {
  const newReceipts = [
    ...receipts,
    createNewReceipt(0, 0), // Fees will be recalculated below
  ];

  return redistributeFees(newReceipts, separateFeeAmount, immediateFeeAmount);
};
